import apiRequest from './apiRequest';

interface JoinWaitlistResponse {
  success: boolean;
}

export default async function postJoinWaitlist(
  email: string,
  excitedAbout?: string,
) {
  const { data, error } = await apiRequest<JoinWaitlistResponse>(
    'user',
    '/users/waitlist',
    {
      method: 'POST',
      body: JSON.stringify({ email, excitedAbout }),
    },
  );

  return { data, error };
}
